export default {
  /** 获取物流服务产品接口 */
  getCourierList: '/api/express/new_guide_express',
}
